import { render, staticRenderFns } from "./EditCohortModal.vue?vue&type=template&id=89e3ebc4&"
import script from "./EditCohortModal.vue?vue&type=script&lang=js&"
export * from "./EditCohortModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports